/* * * ././login.service.ts * * */
// Imports
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
// import { CustomerPanel } from '../../customerpanel/customer_panel';
import { Observable } from 'rxjs';

import { CoreService, CustomerUser } from '../../services/core.service';
import { Login } from '../login';
import { map } from 'rxjs/operators';
import { lg } from '~/modules/colorLog';
import { uiHelper } from '~/helpers/ui.helper';
import { OddConstant } from '~/constant/odd.constant';

// import { Header } from '../../header/header';

declare let $;
declare let TranslateOnlyText;
declare let css;

// Import RxJs required methods

@Injectable()
export class LoginService {
    public LoginState = 0;
    public hasLoginError: boolean;
    public LoginMessageContent: string;
    public credentialsun: string;
    public credentialspw: string;
    public res: Response;
    public responseString: string;
    public inverted: string;
    public loginFirstFlag;

    private apisUrl = '/API/';
    private loginsUrl = '/Login/';

    public firstLoginReceived: EventEmitter<any> = new EventEmitter();

    constructor(private http: HttpClient, private _uiHelper: uiHelper, private _OddConstant: OddConstant) {
        this.hasLoginError = false;
    }

    public signIn(
        email: string,
        password: string,
        __RequestVerificationToken: string,
        langId: string,
        entry: Entry,
        login: Login,
    ): void {
        // this.inverted = css;
        const bodyString = JSON.stringify(''); // Stringify payload

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        const comp = this as LoginService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('username', email);
        urlParams.append('password', password);
        urlParams.append('langId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.loginsUrl + 'SignIn', body, options)
            .toPromise()
            .then(
                data => {
                    const dataText = data && data['body'];

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.hasLoginError = true;
                            comp.LoginMessageContent = dataText.split('|')[1];
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            comp.hasLoginError = true;
                            comp.LoginMessageContent = TranslateOnlyText(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            entry.IsLoginErrorOccured = false;
                            login.userLoggedInSuccessfully();
                            $('#loginname').popup('hide');
                            $('#Login_Keyboard_Modal').modal('hide');
                            $('#Login_Modal').modal('hide');
                            console.log('login succes');
                            comp.LoginState = 1;

                            // recall client settings

                            this.http
                                .get('/API/' + 'GetClientSetting/')
                                .pipe(map((response: Response) => (response as unknown) as []))
                                .subscribe(resConfig => {
                                    this._OddConstant
                                        .DATA_INITIALIZER({
                                            oddData: {},
                                            forbiddenOddTypes: resConfig['forbiddenOddTypes'],
                                        })
                                        .then(() => {
                                            lg('INIT', 'ALL COMPLETED');
                                        });

                                    if (resConfig['terminalConfig']) {
                                        this._uiHelper.SetTerminalConfig(resConfig['terminalConfig']);

                                        // If terminal config is successfully got, execute reload second screen reload.
                                        this._uiHelper.SendElectronMessage('electronListener', {
                                            type: 'reloadSecondScreen',
                                        });
                                    }
                                });
                        }
                    }
                    entry.IsLoading = false;
                },
                function(error) {
                    console.log(error);
                    this.responseString = 'error|System Error';
                    entry.IsLoading = false;
                },
            );
    }

    public singOut(customerUser: CustomerUser): void {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        this.http.get(this.loginsUrl + 'SignOut', { headers }).subscribe(val => this.res);

        const comp = this as LoginService;
        // window.location.reload();

        comp.CustomerActivity($('input[name="__RequestVerificationToken"]').val(), '2');
    }

    public CustomerActivity(__RequestVerificationToken: string, ActivityCode: string): void {
        // this.inverted = css;
        const bodyString = JSON.stringify(''); // Stringify payload
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('browsername', navigator.appVersion);
        urlParams.append('ActivityCode', ActivityCode);

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.loginsUrl + 'CustomerActivity', body, { headers }) // ...using post request
            .subscribe(
                function(data) {},

                function(error) {},
                function() {},
            );
    }

    public cusLoginFirst(a) {
        const bodyString = JSON.stringify('');
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as LoginService;

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);

        const body = urlParams.toString();
        this.loginFirstFlag = 0;
        this.responseString = '';
        this.http.post(this.loginsUrl + 'CustomerLoginFirst', body, { headers }).subscribe(function(data) {
            const dataText = data.toString();

            if (dataText == '') {
                return 'error|System Error';
            }
            this.loginFirstFlag = Number(dataText);
            // this.router.navigateByUrl('/myaccount/8');
        });
    }
}
